module.exports = __webpack_public_path__ + "img/Wintersonne.094001ad.jpg";